import { Injectable } from '@angular/core';

// Service
import { NetworkService } from '../infrastructure/network.service';
import { ConfigService } from '../infrastructure/config.service';

@Injectable({
  providedIn: 'root'
})
export class UserSecurityService {
  constructor(private configService: ConfigService,
    private networkService: NetworkService) {
  }

  public getAccountList(data: any) {
    return this.networkService.postRequest(this.configService.getAccountListingUrl(), data);
  }
  public getCropEdgeAccountList(data: any) {
    return this.networkService.postRequest(this.configService.getCropEdgeAccountListingUrl(), data);
  }
  public validateEvolve() {
    return this.networkService.getRequest(this.configService.validateEvolveUrl());
  }

  public saveAddToAccount(isAccountReset, data: number[]) {
    return this.networkService.postRequest(this.configService.saveAddToAccountUrl() + '?isAccountReset=' + isAccountReset, data);
  }
  public getChatAccess() {
    return this.networkService.getRequest(this.configService.getChatAccessUrl());
  }
  public getGetLoginAccountId() {
    return this.networkService.getRequest(this.configService.getGetLoginAccountIdUrl());
  }

  // Get Partner SSO Urls
  public getCropEdgePartnerWebsite(crossRefValue) {
    return this.networkService.getRequest(this.configService.getCropEdgeWebsiteUrl() + '?crossRefValue=' + crossRefValue);
  }

  public removeUserSelectedAccount(data: number[]) {
    return this.networkService.postRequest(this.configService.removeUserSelectedAccountUrl(), data);
  }
  public checkSraAccountAccess() {
    return this.networkService.getRequest(this.configService.checkSraAccountAccessUrl());
  }

  public checkEdlpAccess() {
    return this.networkService.getRequest(this.configService.checkEdlpAccessUrl());
  }
  public checkSraApproversAccess() {
    return this.networkService.getRequest(this.configService.checkSraApproversAccessUrl());
  }
}
